import { render } from "./App.vue?vue&type=template&id=1d25e60b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1d25e60b&lang=css"

import exportComponent from "D:\\登录页面\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__